import {
  IDashboardResponseModel,
  IDashboardSettings,
  ISavedFilterModel,
  PageMode,
} from '@crm-framework/dashboard';

import { IDictionaries } from '@crm-package/dictionaries';

import { ISDEMO_FIELD_NAME, TIMEZONE_FIELD_NAME } from './components';
import { dictionariesNamesToManagerKeysMap } from './consts';
import { IDashboardFromServer } from './types';

interface IDashboardMapperParams {
  dictionaries: IDictionaries;
}

export const mapDashboard = (
  sourceDashboard: IDashboardFromServer,
  data: IDashboardMapperParams,
  disableFastMode?: boolean
): IDashboardResponseModel => {
  const { isFastModeSupported, ...dashboard } = sourceDashboard;
  const dictionariesNames = Object.keys(data.dictionaries);

  let settings: Partial<IDashboardSettings> = {};

  if (isFastModeSupported && !disableFastMode) {
    settings = {
      infinityScrollModeEnable: isFastModeSupported,
      pageMode: isFastModeSupported ? PageMode.infinite : PageMode.pages,
    };
  }

  dictionariesNames.forEach((key) => {
    if (dictionariesNamesToManagerKeysMap[key]) {
      dashboard.dictionaries[dictionariesNamesToManagerKeysMap[key]] =
        data.dictionaries[key];
      dashboard.dictionaries[
        `${dictionariesNamesToManagerKeysMap[key]}Created`
      ] = data.dictionaries[key];
    }
  });

  const isDemoFilterEnabled = dashboard.columns.find(
    ({ field }) => field === ISDEMO_FIELD_NAME
  );

  if (isDemoFilterEnabled) {
    isDemoFilterEnabled.isHidden = true;
    mapIsDemoFilter(dashboard.filters);
  }

  const timeZoneFilter = dashboard.columns.find(
    ({ field }) => field === TIMEZONE_FIELD_NAME
  );

  if (timeZoneFilter) {
    dashboard.dictionaries[TIMEZONE_FIELD_NAME] = data.dictionaries.timeZone;
    timeZoneFilter.isHidden = true;
  }

  return { ...dashboard, settings };
};

export const mapIsDemoFilter = (filters: ISavedFilterModel[]) => {
  filters.forEach((filter) => {
    // TODO: refactoring filter.filters types
    if (filter.filters) {
      const isDemoAdded = !!filter.filters.find(
        ({ column }) => column === ISDEMO_FIELD_NAME
      );

      if (!isDemoAdded) {
        filter.filters.push({
          column: ISDEMO_FIELD_NAME,
          condition: 'equalsTo',
          value: 0,
        });
      }
    }
  });
};
